import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'fruizione'
})

export class FruizionePipe implements PipeTransform {
    /**
     * in base al parametro passato si va a settare il percorso che si va ad affontare
     * @param  {string} value
     * @returns icon
     */
    transform(value: string): string {
        let icon: string = "";
        if (value != null) {
            switch (value) {
                case "TURISMO EQUESTRE":
                    icon = '<i class="fas fa-horse"></i>';
                    break;
                case "BICICLETTA DA STRADA":
                case "BICICLETTA ELETTRICA":
                case "BICICLETTA IBRIDA":
                case "MOUNTAIN BIKING":
                    icon = '<i class="fas fa-bicycle"></i>';
                    break;

                case "TREKKING":
                    icon = '<i class="fas fa-walking"></i>';
                    break;
                case "NORDIC WALKING":
                    icon = '<i class="fas fa-hiking"></i>';
                    break;

                default:
                    icon = '<i class="fas fa-users"></i>';
                    break;
            }
        }
        return icon;
    }
}